export default __webpack_public_path__ + "static/media/arrow-down-bold-outline.604e5f81.svg";